import { invertedThemeColorsNBD, mainThemeColorsNBD, sizes } from '@volkswagen-onehub/tokens';
import { isInvertedThemeForm } from '../helpers/form-helpers';

export const COLOR_TOKEN = {
	...(isInvertedThemeForm() ? invertedThemeColorsNBD : mainThemeColorsNBD),
};
export const BORDER = {
	size: sizes.border,
	radius: sizes.borderRadius,
};

export const STYLED_INPUT = {
	margin: {
		top: '14px',
		bottom: '14px',
		left: '10px',
		right: '10px',
	},
	height: '51px',
};

export const STYLED_CTA = {
	width: '300px',
};

export const STYLED_DOUBLE_SELECT = {
	first: {
		width: '140px', // Ancho máximo para mostrar label "Prefijo" completo
	},
	second: {
		width: 'calc(100% - 135px + 12px)',
		marginLeft: '-12px',
	},
};
